import React from 'react';
import { Users, TrendingUp, CheckCircle2, AlertTriangle } from 'lucide-react';

export const Panel = ({ title, subtitle, children, testId, aside }) => (
  <section className="rounded-2xl border border-zinc-800 bg-zinc-950/60 p-5" data-testid={testId}>
    <div className="flex items-start justify-between gap-3 mb-4">
      <div>
        <h3 className="text-sm font-semibold text-white">{title}</h3>
        {subtitle && <p className="text-xs text-zinc-500 mt-0.5">{subtitle}</p>}
      </div>
      {aside}
    </div>
    {children}
  </section>
);

export const Empty = ({ children }) => <p className="text-sm text-zinc-500 py-8 text-center">{children}</p>;

const CARDS = [
  { key: 'learners', label: 'Learners', icon: Users, tone: 'text-teal-300 bg-teal-500/10', fmt: (v) => v },
  { key: 'avg_progress', label: 'Average progress', icon: TrendingUp, tone: 'text-sky-300 bg-sky-500/10', fmt: (v) => `${v}%` },
  { key: 'completion_rate', label: 'Completion rate', icon: CheckCircle2, tone: 'text-amber-300 bg-amber-400/10', fmt: (v, h) => `${v}%`, sub: (h) => `${h.completed} completed` },
  { key: 'at_risk', label: 'At risk', icon: AlertTriangle, tone: 'text-rose-300 bg-rose-500/10', fmt: (v) => v },
];

export const HeadlineCards = ({ headline }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
    {CARDS.map(({ key, label, icon: Icon, tone, fmt, sub }) => (
      <div key={key} className="rounded-2xl border border-zinc-800 bg-zinc-950/60 p-5" data-testid={`insights-card-${key}`}>
        <span className={`inline-flex h-9 w-9 items-center justify-center rounded-xl ${tone}`}><Icon className="h-4 w-4" /></span>
        <p className="mt-4 text-3xl font-semibold text-white tabular-nums" data-testid={`insights-value-${key}`}>{fmt(headline[key], headline)}</p>
        <p className="text-xs text-zinc-500 mt-1">{label}{sub ? ` · ${sub(headline)}` : ''}</p>
      </div>
    ))}
  </div>
);
